const baseUrl = 'api';
const debugUrl = '/bar/independ';
const debugUrlNew = '/api/independ/';

export default {
  plugin: {
    // 查询云端当前插件版本
    getVersion: `/${baseUrl}/common/getPluginVersion`,
  },
  user: {
    // 退出登录
    logout: `/${baseUrl}/logout`,
    // 首页登录
    login: `/${baseUrl}/login`,
    // 首页登录短信
    getLoginSms: `/${baseUrl}/common/getLoginSms`,
    // 注册
    register: `/${baseUrl}/register`,
    // 首页去注册页
    toRegister: `/${baseUrl}/toRegister`,
    // 注册短信验证
    registeredSmsCode: `/${baseUrl}/common/getRegisterSms`,
    // 忘记密码短信验证
    forgetSmsCode: `/${baseUrl}/common/getForgetPwdSms`,
    // 忘记密码
    forgetPwd: `/${baseUrl}/user/forgetPwd`,
    // 获取城市
    getCity: `/${baseUrl}/common/getCity`,
    // 修改用户信息
    updateUserInfo: `/${baseUrl}/user/updateUserInfo`,
    // 登录时绑定微信
    loginWx: `/${baseUrl}/wx/loginWx.htm`,
    // 绑定微信验证微信短信验证码
    sendWxSmsCode: `/${baseUrl}/wx/sendWxSmsCode.htm`,
    // 初始化绑定微信验证微信短信验证码
    sendWxBindSmsCode: `/${baseUrl}/wx/sendWxBindSmsCode.htm`,
    // 账号解冻——1.获取短信
    getUnFreezeSms: `/${baseUrl}/common/getUnFreezeSms`,
    // 账号解冻——2.解冻
    unfreezeAccount: `/${baseUrl}/common/unfreezeAccount`,
    // 获取用户信息
    getUserInfo: `/${baseUrl}/user/getUserInfo`,
    // 意见反馈
    advice: `/${baseUrl}/user/advice`,
    // 图形验证码
    getDragImage: `/${baseUrl}/common/getDragImage`,
    // 开通vip
    openVip: `/${baseUrl}/vip/openVip`,
    // 免费试用
    freeTrial: `/${baseUrl}/vip/freeTrial`,
    // 设置OEM信息
    setOEMInformation: `/${baseUrl}/vip/setOEMInformation`,
    // 获取oem信息
    getOEMInformation: `/${baseUrl}/vip/getOEMInformation`,
    getByReferer: `/${baseUrl}/vip/getByReferer`,
    // 上传图片
    uploadImg: `/${baseUrl}/vip/uploadImg`,
    getVipList: `/${baseUrl}/vip/countVip`,
  },
  bar: {
    // 获取网吧分组列表
    getGroupList: `/${baseUrl}/bargroup/list`,
    // 获取最近远程数
    getRemoteNum: `/${baseUrl}/barremote/count`,
    // 获取服务器离线数
    getServerOfflineBarNum: `/${baseUrl}/bar/offlineCnt`,
    // 获取网吧列表
    getBarList: `/${baseUrl}/bar/list`,
    // 获取全部网吧
    getAllBarList: `/${baseUrl}/bar/listAll`,
    // 获取最近远程的服务器列表
    getRemoteServerList: `/${baseUrl}/barremote/list`,
    // 删除远程协助记录
    delRemoteRecord: `/${baseUrl}/barremote/delete`,
    // 获取网吧下的服务器列表
    getBarServerList: `/${baseUrl}/remote/getBarServerList`,
    // 获取网吧下的路由器远程列表
    getBarRouteList: `/${baseUrl}/router/list`,
    // 获取网吧下的客户机列表
    getBarClientList: `/${baseUrl}/remote/getBarClientList`,
    // 远程
    toRemote: `/${baseUrl}/remote/transferRemote`,
    // 远程cmd
    toRemoteCmd: `/${baseUrl}/remote/remoteCommandCmd`,
    // 获取直连模式和备用远程信息
    getBarRemoteInfo: `/${baseUrl}/remote/getBarRemoteInfo`,
    // 设置直连模式和备用远程
    updateBarRemoteInfo: `/${baseUrl}/remote/updateBarRemoteInfo`,
    // 获取bs自动登录信息
    getAutoLoginInfo: `/${baseUrl}/remote/getAutoLoginInfo`,
    // 更新bs自动登录信息
    updateBsAutoLoginInfo: '/api/remote/updateBsAutoLoginInfo',
    // 路由登录
    routeAutoLogin: `/${baseUrl}/router/login`,
    // 获取品牌列表
    queryTradeMarkList: `/${baseUrl}/router/queryTradeMarkList`,
    // 远程命令
    sendRemoteCommand: `/${baseUrl}/remote/sendRemoteCommand`,
    // 添加路由
    addRouter: `/${baseUrl}/router/add`,
    // 修改路由
    updateRouter: `/${baseUrl}//router/update`,
    // 删除路由
    deleteRouter: `/${baseUrl}/router/delete`,
    // 批量删除路由
    deleteRouterBatch: `/${baseUrl}/router/deleteBatch`,
    // 获取当前网吧信息
    getBarInfo: `/${baseUrl}/remote/getBarInfo`,
    // 注册网吧
    registerBar: `/${baseUrl}/bar/register`,
    //  查询远程协助码
    getAssistRemoteKey: `/${baseUrl}/remote/getAssistRemoteKey`,
    // 生成/销毁协助码
    manageAssistRemoteKey: `/${baseUrl}/remote/manageAssistRemoteKey`,
    // 使用协助吗
    useAssistBar: `/${baseUrl}/remote/assistBar`,
    // 获取修改时所需的网吧信息
    getEditBarInfo: `/${baseUrl}/bar/info`,
    // 修改网吧信息
    updateBarInfo: `/${baseUrl}/bar/update`,
    // 修改网吧密码
    changeBarPwd: `/${baseUrl}/bar/changePwd`,
    // 更改网吧分组
    changeBarGroup: `/${baseUrl}/bar/changeGroup`,
    // 网吧概况
    // getBarEnv: `/${baseUrl}/bar/env`,
    getBarEnv: `/${baseUrl}/securityCenter/getBarEvn`,
    // 获取云笔记
    getCloudNote: `/${baseUrl}/bar/cloudNode`,
    // 修改云笔记
    editCloudNote: `/${baseUrl}/bar/editCloudNode`,
    // 保存分组
    saveGroupName: `/${baseUrl}/bargroup/save`,
    // 删除分组
    delBarGroup: `/${baseUrl}/bargroup/delete`,
    // 获取接收码
    getReceiveCode: `/${baseUrl}/bar/getReceiveCode`,
    // 保存接收码
    saveReceiveCode: `/${baseUrl}/bar/saveReceiveCode`,
    // 获取转移网吧数量
    getTransferCnt: `/${baseUrl}/bar/getTransferCnt`,
    // 获取标签列表
    getLabelList: `/${baseUrl}/label/getLabelList`,
    // 修改标签名称
    editLabelName: `/${baseUrl}/label/saveLabel`,
    // 删除标签
    delLabelName: `/${baseUrl}/label/deleteLabel`,
    // 分页获取服务器列表
    getServerList: `/${baseUrl}/label/getBarserverList`,
    // 为服务器设置标签
    setServerLabel: `/${baseUrl}/label/setBarserverLabel`,
    // 删除离线服务器
    delOfflineBs: `/${baseUrl}/remote/deleteOfflineBs`,
  },
  emplyee: {
    // 员工管理
    // 获取列表
    getTableList: `/${baseUrl}/childpassport/list`,
    // 删除
    del: `/${baseUrl}/childpassport/delete`,
    // 状态
    status: `/${baseUrl}/childpassport/freezeState`,
    // 备注
    mark: `/${baseUrl}/childpassport/updateRemark`,
    // 注册子账号
    registerAdd: `/${baseUrl}/childpassport/add`,
    // 修改
    edit: `/${baseUrl}/childpassport/update`,
    // 查询网吧分组列表
    getSearchGroupNameList: `/${baseUrl}/childpassport/queryBarGroupList`,
    // 查询网吧列表列表
    getSearchBarNameList: `/${baseUrl}/childpassport/queryBarList`,
    getsmscode: '/api/childpassport/getSafeValidateSms',
    switchSafeCenter: '/api/childpassport/switchSafeCenter',
    switchDllFlag: '/api/childpassport/switchDllFlag',
  },
  // 操作日志
  operationLog: {
    // 获取列表
    getTableList: `/${baseUrl}/userlog/list`,
    // 操作平台列表
    // getOperaPlarformList:`/${baseUrl}/userlog/operatPlatformList`,
    // 事件类型列表
    getEventTypeList: `/${baseUrl}/userlog/types`,
    // 远程操作日志
    addRemoteLog: `/${baseUrl}/remote/addRemoteLog`,
  },
  // 安全中心
  securityCenter: {
    getRuleManageList: `/${baseUrl}/securityCenter/ruleManageList`, // 获取安全规则管理列表
    editRule: `/${baseUrl}/securityCenter/editRule`, // 新建、修改规则
    delRule: `/${baseUrl}/securityCenter/delRule`, // 删除规则
    enabledRule: `/${baseUrl}/securityCenter/enabledRule`, // 禁用、启用规则
    importFile: `/${baseUrl}/securityCenter/importRule`, // 导入规则
    exportFile: `/${baseUrl}/securityCenter/export`, // 导出规则
    applySecurityGroup: `/${baseUrl}/securityCenter/applySecurityGroup`, // 应用到安全组
    listSelectLabel: `/${baseUrl}/securityCenter/listSelectLabel`, // 网吧查询-下拉类表查询
    listSoftType: `/${baseUrl}/securityCenter/listSoftType`, // 网吧查询-软件类型二级查找
    getBarList: `/${baseUrl}/securityCenter/getBarList`, // 获取网吧列表
    protectionOpenOrClose: `/${baseUrl}/securityCenter/protectionOpenOrClose`, // 开启、关闭防护
    moveSecurityGroup: `/${baseUrl}/securityCenter/mobileSecurityGroup`, // 移动安全组
    environmentSettings: `/${baseUrl}/securityCenter/environmentSettings`, // 环境设置
    editSecurityGroup: `/${baseUrl}/securityCenter/editSecurityGroup`, // 安全组添加修改
    delSecurityGroup: `/${baseUrl}/securityCenter/delSecurityGroup`, // 删除安全组
    listEvnInfo: `/${baseUrl}/securityCenter/listEvnInfo`, // 环境设置-环境列表
    payOrder: `/${baseUrl}/accel/payOrder`, // 支付宝微信支付
    getRuleText: `/${baseUrl}/securityCenter/getById`, // 获取规则内容
    getSecurityGroupList: `/${baseUrl}/securityCenter/listSecurityGroup`, // 获取安全组列表
    addRuleShare: `/${baseUrl}/securityCenter/addRuleShare`, // 添加分享
    ruleShareList: `/${baseUrl}/securityCenter/ruleShareList`, // 共享规则库
    getRuleShare: `/${baseUrl}/securityCenter/getRuleShare`, // 获取某条规则是否分享过
    getLogPageById: `/${baseUrl}/securityCenter/getLogPageById`, // 分享记录
    createClient: `/${baseUrl}/independ/createClient`, // 创建客户端
    checkClient: `/${baseUrl}/independ/checkClient`, // 判断是否打包成功
    updateRuleShare: `/${baseUrl}/securityCenter/updateRuleShare`, // 更新共享id
    applyRule2SecurityGroup: `/${baseUrl}/securityCenter/applyRule2SecurityGroup`,
  },
  // 三层任务
  threeTierMission: {
    tableList: `/${baseUrl}/threeTierMission/listTask`, // 获取三层任务列表
    usage: `/${baseUrl}/threeTierMission/usage`, // 空间使用情况，使用流量情况
    disableOrenable: `/${baseUrl}/threeTierMission/disableOrEnable`, // 启用、停用
    delTask: `/${baseUrl}/threeTierMission/delTask`, // 删除任务
    createTask: `/${baseUrl}/threeTierMission/addTask`, // 创建服务器/客户机任务
    uploadFile: `/${baseUrl}/threeTierMission/addFile`, // 上传文件
    getRuleType: `/${baseUrl}/threeTierMission/getRunType`, // 获取执行方式
    relatedBar: `/${baseUrl}/threeTierMission/relatedBar`, // 关联网吧
    getClientTableList: `/${baseUrl}/threeTierMission/listClientTask`, // 获取客户机网吧列表
    getServerTableList: `/${baseUrl}/threeTierMission/listServerTask`, // 获取服务器任务网吧列表
    getFileList: `/${baseUrl}/threeTierMission/getFileList`, // 获取文件管理列表
    delFile: `/${baseUrl}/threeTierMission/delFile`, // 文件管理--删除
    editRemark: `/${baseUrl}/threeTierMission/editRemark`, // 文件管理--备注修改
    getAllFile: `/${baseUrl}/threeTierMission/getAllFile`, // 获取全部上传文件
  },
  // 账号安全
  safe: {
    // 重置修改密码
    getResetPwd: `/${baseUrl}/user/resetPwd`,
    // 重置密码获取短信
    getResetSms: `/${baseUrl}/user/getResetPwdSms`,
    // 绑定微信登录
    getBindWx: `/${baseUrl}/wx/bindWx.htm`,
    // 解绑微信登录
    getUnbindWx: `/${baseUrl}/wx/unbindWx.htm`,
    // 获取原手机短信
    getRestPhoneOldSms: `/${baseUrl}/user/getRestPhoneOldSms`,
    // 验证原手机号
    resetPhoneValidateOld: `/${baseUrl}/user/resetPhoneValidateOld`,
    // 获取新手机短信
    getResetPhoneNewSms: `/${baseUrl}/user/getResetPhoneNewSms`,
    // 修改绑定手机
    resetPhone: `/${baseUrl}/user/resetPhone`,
    // 开启/关闭短信验证——1.获取短信
    getSaveTypeSms: `/${baseUrl}/user/getSaveTypeSms`,
    // 开启/关闭短信验证——2.开启/关闭
    saveValidateType: `/${baseUrl}/user/saveValidateType`,
    // 微信发送短信验证码
    sendWxSmsCode: `/${baseUrl}/wx/sendWxSmsCode.htm`,
    // 验证微信短信验证码
    validateWxSmsCode: `/${baseUrl}/wx/validateWxSmsCode.htm`,
  },
  module: {
    // 获取城市-麦子
    getCity: `/${baseUrl}/common/getCity`,
  },
  // 留言板
  message: {
    // 获取网吧列表
    getBarList: `/${baseUrl}/getBarList`,
    // 获取留言数
    getMessageNum: `/${baseUrl}/getMessageNum`,
    // 获取留言
    getMessage: `/${baseUrl}/getMessage`,
    // 网吧留言配置
    barSet: `/${baseUrl}/barSet`,
    // 发送留言
    send: `/${baseUrl}/bbs-leave-message/send`,
  },
  selfClient: {
    getPageOfBar: `/${baseUrl}/independ/getPageOfBar`,
    getPageOfClient: `/${baseUrl}/independ/getPageOfClient`,
    getPageOfDevice: `/${baseUrl}/independ/getPageOfDevice`,
    getPageOfSoft: `/${baseUrl}/independ/getPageOfSoft`,
  },
  debugModel: {
    delRuleByBarId: debugUrl + '/delRuleByBarId',
    addRuleByBarId: debugUrl + '/addRuleByBarId',
    updateRuleByBarId: debugUrl + '/updateRuleByBarId',
    // getDebugCfgByBarId: debugUrl + '/getDebugCfgByBarId', // 获取网吧调试模式状态
    addDebugCfgByBarId: debugUrl + '/addDebugCfgByBarId',
    delDebugCfgByBarId: debugUrl + '/delDebugCfgByBarId',
    updateDebugCfgByBarId: debugUrl + '/updateDebugCfgByBarId',
    onDebugCfgByBarId: debugUrl + '/onDebugCfgByBarId', // 开启调试模式
    offDebugCfgByBarId: debugUrl + '/offDebugCfgByBarId', // 关闭调试模式
    updateDebugIpByBarId: debugUrl + '/updateDebugIpByBarId', // 修改调试IP
    getRuleByBarId: debugUrl + '/getRuleByBarId', // 获取网吧的规则
    setDebugRuleByRuleId: debugUrl + '/setDebugRuleByRuleId', // 根据用户规则标识添加缓存的调试规则
    delDebugRuleByRuleId: debugUrl + '/delDebugRuleByRuleId', // 根据用户规则标识删除缓存的调试规则
    addDebugRuleByBarId: debugUrl + '/addDebugRuleByBarId', // 添加调试规则
    updateDebugRuleByBarId: debugUrlNew + '/updateDebugRuleByBarId', // 修改调试规则
    // updateDebugRuleByBarId: debugUrl + '/updateDebugRuleByBarId', // 修改调试规则
    //
    searchBarList: `/${baseUrl}/bar/searchBarList`, // 搜索网吧
    getBarList: `/${baseUrl}/bar/getBarList`, // 获取网吧
    getLog: 'http://116.62.42.136:8898/log',
    switchBarLog: '/api/independ/switchBarLog', // 拦截记录
    delBar: '/api/independ/delBar', // 删除网吧
    updateBarName: '/api/bar/updateBarName', // 改名
    switchClientDebug: '/api/independ/switchClientDebug', // 调试开关
    delClient: '/api/independ/delClient', // 删除客户端
    restartClient: '/api/independ/restartClient', // 重启客户端
    getDebugCfgByBarId: debugUrlNew + '/getDebugRuleByBarId', // 查询网吧调试规则
    // getDebugCfgByBarId: debugUrl + '/getRuleByBarId', // 查询网吧调试规则
    queryClientOnline: debugUrlNew + '/queryClientOnline', // 查询所有进程树
    getGroupList: '/api/securityCenter/getGroupList', // 获取安全分组列表
    getProTree: '/api/independ/getProTree', // 获取终端进程树
    getProDetail: '/api/independ/getProDetail', // 进程明细
    getBarListNew: '/api/independ/getListOfBar', // 获取网吧列表
    switchClientHafman: '/api/independ/switchClientHafman', // 开启或关闭hifiman
    getLogDirOfBar: '/api/independ/getLogDirOfBar', // 获取终端日志地址
    getLogSearch: '/api/independ/getLogSearch', // 获取日志列表
    getLogTitle: '/api/independ/getLogTitle', // 获取日志表头
    getLogList: '/api/independ/getLogList', // 获取日志内容
    getProcess: '/api/independ/getProcess', //
  },
  agreement: {
    agreementSecurity: '/api/independ/agreementSecurity', // 确定同意
    queryAgreementSecurity: '/api/independ/queryAgreementSecurity', // 查询状态
    getSupportInfo: '/api/staff/getSupportInfo', // 获取技术支持信息
  },
  taskModel: {
    findPage: '/api/independ/strategy/findPage', // 获取任务列表
    edit: '/api/independ/dllStrategy/edit', // 编辑
    singleDetail: '/api/independ/strategy/singleDetail', //
    batchSwitch: '/api/independ/strategy/switchStatus', // 批量启用停用
    batchDel: '/api/independ/strategy/batchDel',
    getBarSecGroup: '/api/independ/getBarSecGroup', // 网吧及安全组列表
    applyStrategy: '/api/independ/strategy/applyStrategy', // 应用到网吧
    exeStrategyEditor: '/api/independ/exeStrategy/edit',
    switchBarStatus: '/api/independ/strategy/switchBarStatus', // 开关网吧
    sysFileAdd: '/api/independ/sysFile/add', // 上传文件
    sysFilePage: '/api/independ/sysFile/page', // 获取列表
    sysFileBatchDel: '/api/independ/sysFile/batchDel',
    sysFileEdit: '/api/independ/sysFile/edit', // 修改
    getHostProcs: '/api/independ/getHostProcs', // 获取宿主列表
    switchBarExeStatus: '/api/independ/strategy/switchBarExeStatus',
    exeRunLog: '/api/independ/exeRunLog/page', // 通道日志
  },
};
